const data = {
  Program: {
    id: 1,
    programName: {
      "@max": 64,
    },
    programRemarks: {
      "@max": 64,
    },
    shareProperty: {
      "@opt": "public,private",
    },
    approveState: {
      "@opt": "approved,notPass,notApprove",
    },
    collectProperty: {
      "@opt": "collected, not collected",
    },
    approveRemarks: {
      "@max": 128,
    },
    programType: {
      "@opt": "normal,decode,touch,decodeTouch,doubleSide",
    },
    orgNo: 1,
    Resolution: {
      resolutionName: {
        "@opt": "1920*1080,1080*1920,selfDefine",
      },
      imageWidth: {
        "@min": 120,
        "@max": 3840,
      },
      imageHeight: {
        "@min": 120,
        "@max": 3840,
      },
      "4KResolution": {
        "@min": 2160,
        "@max": 3840,
      },
    },
    PageList: [
      {
        "@size": 32,
      },
    ],
    CascadeResolution: {
      resolutionName: {
        "@opt": "1920*1080,1080*1920",
      },
      imageWidth: {
        "@min": 120,
        "@max": 3840,
      },
      imageHeight: {
        "@min": 120,
        "@max": 3840,
      },
      "4KResolution": {
        "@min": 2160,
        "@max": 3840,
      },
    },
    coordinateType: {
      "@opt": "uniformCoordinate,resolutionCoordinate",
    },
    applicationType: {
      "@opt":
        "normal,signIn,peopleConting,conference,doubleSide,cascadeProgram,emergencyProgram",
    },
    screenType: {
      "@opt": "first,second",
    },
    audioEnabled: {
      "@opt": "true,false",
    },
    CascadeSize: {
      row: {
        "@min": 1,
        "@max": 10,
      },
      column: {
        "@min": 1,
        "@max": 10,
      },
      isSupportMultiRowAndColumn: "false",
    },
  },
};
export default data;
